import { Redirect, Switch, Route } from "react-router-dom";
import Login from "./pages/auth/Login";
import Forgot from "./pages/auth/Forgot";
import Home from "./pages/Home";
import { useSelector } from "react-redux";
// import '../node_modules/materialize-css/dist/css/materialize.min.css';
// import '../node_modules/materialize-css/dist/js/materialize.min.js';
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import '../node_modules/bootstrap/dist/js/bootstrap.min.js'
import "@popperjs/core";
import "./App.css";
import Loading from "./components/Loading";
import { useAutoLogin } from "./hooks/useAutoLogin";
import Employees from "./pages/employee/Employees";
import Admins from "./pages/admin/Admins";
import Teams from "./pages/team/Teams";
import AddUser from "./pages/user/AddUser";
import AddTeam from "./pages/team/AddTeam";
import Employee from "./pages/employee/Employee";
import Team from "./pages/team/team/Team";
import EditUser from "./pages/user/EditUser";
import EditTeam from "./pages/team/EditTeam";
import Admin from "./pages/admin/Admin";
import "./App.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/components.css";
import Leaders from "./pages/leader/Leaders";
import SideBar from "./components/sidebar";
import Navigation from "./components/navigation";
import Members from "./pages/leaderpage/Members";
import UserTeams from "./components/Employees/UserTeams";
import Attendance from "./components/Employees/Attendance";
import LeaveApplications from "./components/Employees/LeaveApplications";
import Salary from "./components/Employees/Salary";
import ApplyForLeave from "./components/Employees/ApplyForLeave";
import EmployeeTeam from "./pages/team/team/EmployeeTeam";
import LeaveApplication from "./components/Employees/LeaveApplication";
import DashboardEmployee from "./components/DashboardEmployee";
import AttendanceView from "./components/Admin/AttendanceView";
import LeaveView from "./components/Admin/LeaveView";
import Leave from "./components/Admin/Leave";
import AssignSalary from "./components/Admin/AssignSalary";
import Salaries from "./components/Admin/Salaries";
import SalaryView from "./components/Admin/Salary";
import Notices from "./components/Admin/SendNotice";
import Payslip from "./components/Employees/Payslip";
import ContactUs from "./pages/contact/contactus";
import FloatingButton from "./components/FloatingButton";
import NoticesPage from "./components/NoticePages";
import TeamLeaveDetails from "./components/Employees/TeamLeaveDetails";
import InternTeams from "./components/Intern/InternTeams";
import InternTeamView from "./components/Intern/InternTeamView";
import InternDashboard from "./components/dashboard/Intern";
import InternAttendance from "./components/Intern/InternAttendance";
import InternLeaveApplication from "./components/Intern/InternLeaveApplication";
import InternLeaveApplications from "./components/Intern/InternLeaveApplications";
import InternLeaveDetails from "./components/Intern/InternLeaveDetails";
import InternPayslip from "./components/Intern/InternPayslip";
import InternContactUs from "./pages/contact/contactus";
import InternSalary from "./components/Intern/InternSalary";
import InternReport from "./components/Intern/InternReport";
import InternReportsView from "./components/Admin/InternReportsView";
import AttendanceSummary from "./components/Admin/AttendanceSummary";
import LeaveManagement from "./components/Admin/LeaveManagement";
import JobCreation from "./components/Admin/Job Creation";
import ViewJobs from "./components/Admin/View Jobs";
import CreateCandidate from "./components/Admin/CreateCandidate";
import ViewCandidate from "./components/Admin/ViewCandidate";
import CandidateSourcing from "./components/Admin/CandidateSourcing";
// import './assets/css/asdfasdf';
// import './assets/css/asdfasdf';

const App = () => {
  const loading = useAutoLogin();

  return loading ? (
    <Loading />
  ) : (
    <>
      <FloatingButton />
      <Switch>
        <EmployeeRoute exact path="/userTeams">
          <UserTeams />
        </EmployeeRoute>
        <EmployeeRoute exact path="/userteam/:id">
          <EmployeeTeam />
        </EmployeeRoute>
        <EmployeeRoute exact path="/dashboardEmployee">
          <DashboardEmployee />
        </EmployeeRoute>
        <EmployeeRoute exact path="/userAttendance">
          <Attendance />
        </EmployeeRoute>
        <EmployeeRoute exact path="/applyforleave">
          <ApplyForLeave />
        </EmployeeRoute>
        <EmployeeRoute exact path="/userSalary">
          <Salary />
        </EmployeeRoute>
        <EmployeeRoute exact path="/userLeaveApplications">
          <LeaveApplications />
        </EmployeeRoute>
        <EmployeeRoute exact path="/userLeaveApplications/:id">
          <LeaveApplication />
        </EmployeeRoute>
        <EmployeeRoute exact path="/teamLeaveDetails/:id">
          <TeamLeaveDetails />
        </EmployeeRoute>
        <EmployeeRoute exact path="/userPayslip">
          <Payslip />
        </EmployeeRoute>
        <EmployeeRoute exact path="/notices">
          <NoticesPage />
        </EmployeeRoute>
        <EmployeeRoute exact path="/contact">
          <ContactUs />
        </EmployeeRoute>
        <InternRoute exact path="/intern/teams">
          <InternTeams />
        </InternRoute>
        <InternRoute exact path="/intern/team/:id">
          <InternTeamView />
        </InternRoute>
        <InternRoute exact path="/intern/dashboard">
          <InternDashboard />
        </InternRoute>
        <InternRoute exact path="/intern/attendance">
          <InternAttendance />
        </InternRoute>
        <InternRoute exact path="/intern/leave/apply">
          <InternLeaveApplication />
        </InternRoute>
        <InternRoute exact path="/intern/salary">
          <InternSalary />
        </InternRoute>
        <InternRoute exact path="/intern/leave/applications">
          <InternLeaveApplications />
        </InternRoute>
        <InternRoute exact path="/intern/leave/application/:id">
          <InternLeaveDetails />
        </InternRoute>
        <InternRoute exact path="/intern/payslip">
          <InternPayslip />
        </InternRoute>
        <InternRoute exact path="/intern/contact">
          <InternContactUs />
        </InternRoute>
        <InternRoute exact path="/intern/report">
          <InternReport />
        </InternRoute>
        <GuestRoute exact path="/">
          <Login />
        </GuestRoute>
        <GuestRoute exact path="/login">
          <Login />
        </GuestRoute>
        <GuestRoute exact path="/forgot">
          <Forgot />
        </GuestRoute>
        <ProtectedRoute exact path="/home">
          <Home />
        </ProtectedRoute>
        <AdminRoute exact path="/employees">
          <Employees />
        </AdminRoute>
        <AdminRoute exact path="/intern-reports">
          <InternReportsView />
        </AdminRoute>
        <LeaderRoute exact path="/members">
          <Members />
        </LeaderRoute>
        <AdminRoute exact path="/admins">
          <Admins />
        </AdminRoute>
        <AdminRoute exact path="/teams">
          <Teams />
        </AdminRoute>
        <AdminRoute exact path="/adduser">
          <AddUser />
        </AdminRoute>
        <AdminRoute exact path="/attendance">
          <AttendanceView />
        </AdminRoute>
        <AdminRoute exact path="/create-job">
          <JobCreation />
        </AdminRoute>
        <AdminRoute exact path="/create-cand">
          <CreateCandidate />
        </AdminRoute>
        <AdminRoute exact path="/view-candidates">
          <ViewCandidate />
        </AdminRoute>
        <AdminRoute exact path="/candidate-sourcing">
          <CandidateSourcing />
        </AdminRoute>
        <AdminRoute exact path="/view-jobs">
          <ViewJobs />
        </AdminRoute>
        <AdminRoute exact path="/attendance-summary">
          <AttendanceSummary />
        </AdminRoute>
        <AdminRoute exact path="/leaves">
          <LeaveView />
        </AdminRoute>
        <AdminRoute exact path="/assignSalary">
          <AssignSalary />
        </AdminRoute>
        <AdminRoute exact path="/salaries">
          <Salaries />
        </AdminRoute>
        <AdminRoute exact path="/leaves/:id">
          <Leave />
        </AdminRoute>
        <AdminRoute exact path="/leaves-management">
          <LeaveManagement />
        </AdminRoute>
        <AdminRoute exact path="/salary/:id">
          <SalaryView />
        </AdminRoute>
        <AdminRoute exact path="/notice">
          <Notices />
        </AdminRoute>
        <AdminRoute exact path="/addteam">
          <AddTeam />
        </AdminRoute>
        <ProtectedRoute path="/employee/:id">
          <Employee />
        </ProtectedRoute>
        <AdminRoute path="/team/:id">
          <Team />
        </AdminRoute>
        <ProtectedRoute path="/edituser/:id">
          <EditUser />
        </ProtectedRoute>
        <AdminRoute path="/editteam/:id">
          <EditTeam />
        </AdminRoute>
        <AdminRoute path="/admin/:id">
          <Admin />
        </AdminRoute>
        {/* <AdminRoute exact path="/contact">
        <ContactUs />
      </AdminRoute> */}
        <AdminRoute path="/leaders">
          <Leaders />
        </AdminRoute>
      </Switch>
    </>
  );
};

const GuestRoute = ({ children, ...rest }) => {
  const { isAuth } = useSelector((state) => state.authSlice);
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return isAuth ? (
          <Redirect to={{ pathname: "/home", state: { from: location } }} />
        ) : (
          children
        );
      }}></Route>
  );
};

const ProtectedRoute = ({ children, ...rest }) => {
  const { isAuth } = useSelector((state) => state.authSlice);
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return isAuth ? (
          <>
            <SideBar />
            <Navigation />
            {children}
          </>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: {
                from: location,
              },
            }}
          />
        );
      }}
    />
  );
};

const AdminRoute = ({ children, ...rest }) => {
  const { user } = useSelector((state) => state.authSlice);
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return user && user.type === "Admin" ? (
          <>
            <SideBar />
            <Navigation />
            {children}
          </>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: {
                from: location,
              },
            }}
          />
        );
      }}
    />
  );
};

const LeaderRoute = ({ children, ...rest }) => {
  const { user } = useSelector((state) => state.authSlice);
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return user && user.type === "Leader" ? (
          <>
            <SideBar />
            <Navigation />
            {children}
          </>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: {
                from: location,
              },
            }}
          />
        );
      }}
    />
  );
};

const EmployeeRoute = ({ children, ...rest }) => {
  const { user } = useSelector((state) => state.authSlice);
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return (user && user.type === "Employee") || user.type === "Leader" ? (
          <>
            <SideBar />
            <Navigation />
            {children}
          </>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: {
                from: location,
              },
            }}
          />
        );
      }}
    />
  );
};

const InternRoute = ({ children, ...rest }) => {
  const { user } = useSelector((state) => state.authSlice);
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return user && user.type === "Intern" ? (
          <>
            <SideBar />
            <Navigation />
            {children}
          </>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: {
                from: location,
              },
            }}
          />
        );
      }}
    />
  );
};

export default App;
